export interface CountBoundsInput {
  min: string;
  max: string;
}

export const parseCountToBounds = (value?: string | null): CountBoundsInput => {
  if (!value) return { min: "", max: "" };
  const trimmed = String(value).trim();
  const parts = trimmed.split("-");
  if (parts.length === 2) {
    return { min: parts[0], max: parts[1] };
  }
  return { min: trimmed, max: "" };
};

export const normalizeCountFromBounds = (minRaw?: string, maxRaw?: string): string | null => {
  const minValue = (minRaw || "").trim();
  const maxValue = (maxRaw || "").trim();
  if (!/^\d+$/.test(minValue)) return null;
  const min = Number(minValue);
  if (!Number.isInteger(min) || min <= 0) return null;

  if (!maxValue) return String(min);
  if (!/^\d+$/.test(maxValue)) return null;
  const max = Number(maxValue);
  if (!Number.isInteger(max) || max <= 0 || max < min) return null;
  if (max === min) return String(min);
  return `${min}-${max}`;
};

export const countSortKey = (count?: string | null): number => {
  if (!count) return Number.NEGATIVE_INFINITY;
  const normalized = String(count).trim();
  if (/^\d+$/.test(normalized)) return Number(normalized);
  const match = normalized.match(/^(\d+)-(\d+)$/);
  if (!match) return Number.NEGATIVE_INFINITY;
  const min = Number(match[1]);
  const max = Number(match[2]);
  return (min + max) / 2;
};
